var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMsTeams = function SvgMsTeams(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipPath: "url(#ms_teams_svg__a)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#ms_teams_svg__b)",
    d: "M15.229 1.405c1.041 0 1.885.823 1.885 1.84 0 1.015-.844 1.839-1.885 1.839-1.042 0-1.886-.824-1.886-1.84s.844-1.84 1.886-1.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ms_teams_svg__c)",
    d: "M17.272 6.183h-4.077c-.4 0-.728.32-.728.71v3.895c0 1.46 1.226 2.657 2.723 2.657h.085c1.498 0 2.724-1.196 2.724-2.657V6.892c0-.39-.328-.71-.728-.71h.001Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ms_teams_svg__d)",
    d: "M9.458 0c1.44 0 2.606 1.137 2.606 2.542 0 1.405-1.166 2.542-2.606 2.542S6.853 3.947 6.853 2.542C6.853 1.137 8.02 0 9.458 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ms_teams_svg__e)",
    d: "M13.197 6.183H5.72a.728.728 0 0 0-.734.716v4.805c0 2.363 1.982 4.295 4.404 4.295h.137c2.422 0 4.403-1.933 4.403-4.295V6.899a.728.728 0 0 0-.734-.716h.001Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ms_teams_svg__f)",
    d: "M.72 12.439h7.607c.396 0 .72-.316.72-.703v-7.42a.714.714 0 0 0-.72-.703H.72a.714.714 0 0 0-.72.703v7.42c0 .386.324.703.72.703Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ms_teams_svg__g)",
    d: "M.72 12.439h7.607c.396 0 .72-.316.72-.703v-7.42a.714.714 0 0 0-.72-.703h-.046c.391 0 .711.313.711.694v7.377c0 .381-.32.694-.71.694H.765a.705.705 0 0 1-.71-.694V4.307c0-.381.32-.694.71-.694H.72a.714.714 0 0 0-.72.703v7.42c0 .386.324.703.72.703Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ms_teams_svg__h)",
    d: "M2.43 5.746h3.824v.78H4.819v3.78h-.953v-3.78H2.43v-.78Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ms_teams_svg__b",
    x1: 19.058,
    x2: 15.26,
    y1: 3.935,
    y2: 2.737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A5FCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C245F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ms_teams_svg__c",
    x1: 20.113,
    x2: 14.306,
    y1: 10.766,
    y2: 9.405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5468E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F3C90"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ms_teams_svg__d",
    x1: 13.68,
    x2: 8.431,
    y1: 3.41,
    y2: 1.755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B80F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#464FA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ms_teams_svg__e",
    x1: 15.769,
    x2: 6.586,
    y1: 12.479,
    y2: 9.905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8094FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5060DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ms_teams_svg__f",
    x1: 10.397,
    x2: 1.285,
    y1: 9.797,
    y2: 6.923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3744AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#243176"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ms_teams_svg__g",
    x1: 1.034,
    x2: 10.608,
    y1: 8.424,
    y2: 8.424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5160B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#2E3C8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5367E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ms_teams_svg__h",
    x1: 3.606,
    x2: 7.652,
    y1: 8.423,
    y2: 8.423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1CFCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFEFE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ms_teams_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h18v16H0z"
  })))));
};
export default SvgMsTeams;